module.exports = __webpack_public_path__ + "img/bill-bgHead1.0f13c0dd.png";